// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__E5Uut","rightAdornment":"Header_rightAdornment__jSi5_"};